export default function truncateText(text: string, maxLen: number, separator: string = ' ', ellipsis: string = '...'): string {
  if (text.length <= maxLen) {
    return text
  }

  return `${text.slice(0, text.lastIndexOf(separator, maxLen))}${ellipsis}`
}
